/**
 * 时间戳转换成字符串格式日期
 * @param {NUmber} date 时间搓
 * @param {String} format 时间格式
 */
import moment from 'moment';

const dateFormat = (date, format = 'YYYY-MM-DD HH:mm:ss') => {
  if (!date) return '';
  return moment(new Date(date)).format(format);
};

export default dateFormat;
